import { init } from "@rematch/core";
import createLoadingPlugin from "@rematch/loading";
import createRematchPersist from "@rematch/persist";

import notification from "../modules/notification/models";
import getReport from "../modules/search/models";
import { bound, getPolygon, getStats } from "../modules/stats/models";

const loadingPlugin = createLoadingPlugin();

const persistPlugin = createRematchPersist({
  whitelist: ["auth"],
  throttle: 5000,
  version: 1,
});

const store = init({
  plugins: [loadingPlugin, persistPlugin],
  models: {
    notification,
    getReport,
    bound,
    getPolygon,
    getStats,
  },
  redux: {
    devtoolOptions: {
      disabled: true,
    },
  },
});

export default store;
